/* @flow */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import type { $Dealer } from 'CoreTypes';
import type { $StoreState } from '../../types/StoreState';
import Globals from 'CoreConstants/Globals';
import Pagination from 'CoreComponents/Pagination/Pagination';
import DealerData from '../DealerData/DealerData';
import ProgressLoader from 'CoreComponents/ProgressLoader/ProgressLoader';
import { TrackingAttributes } from 'CoreConstants/Tracking';
import { TemplateMarketPropertyKeys } from 'CoreTemplates/TemplateMarketProperties';
import { getConfigurationMarketProperty } from 'CoreUtils/WidgetUtils';
import { findDealersListPage } from '../../store/search';
import { setDealersListPage } from '../../store/search';

type $ComponentProps = {
  results: Array<Array<$Dealer>>
};

type $MappedProps = {
  selectDealerCallback: Function,
  pageSize: number,
  totalResults: number,
  findDealersListPage: Function,
  setDealersListPage: Function
};

type $Props = $ComponentProps & $MappedProps;

type $State = {
  selectedPage: number
};

class SearchResultsList extends Component<$Props, $State> {

  state = {
    selectedPage: 1
  };

  handlePaginationChange = (selectedPage: number) => {
    this.setState({
      selectedPage
    }, () => {
      this.props.setDealersListPage(this.state.selectedPage);
    });
  };

  componentDidUpdate() {
    const pageResults = this.props.results[this.state.selectedPage-1];
    const isPageMiss = pageResults.length === 0;
    if (isPageMiss) {
      this.props.findDealersListPage(this.state.selectedPage);
    }
  }

  render() {
    const { results, selectDealerCallback, pageSize, totalResults } = this.props;
    const pagesTotal = Math.ceil(totalResults / pageSize);
    const pageResults = results[this.state.selectedPage-1];

    return (
      <div className="dsw-search-results-list">
        {pageResults.length > 0 ? (
          pageResults.map((dealer: $Dealer, idx: number) => (
            <DealerData
              key={idx}
              dealer={dealer}
              selectDealerCallback={selectDealerCallback}
              trackingLinkPosition={TrackingAttributes.LINK_POSITION_DSW_DEALER_LIST}
            />
          ))
        ) : (
          <div className="dsw-search-result-list-loader">
            <div className="dsw-search-result-list-loader--wrapper">
              <ProgressLoader loading />
            </div>
          </div>
        )}
        {pagesTotal > 1 &&
          <Pagination
            pageCount={pagesTotal}
            onPageChange={this.handlePaginationChange}
            wrapperClassName="dsw-search-results-list__pagination"
          />
        }
      </div>
    );
  }
}

const mapStateToProps = (state: $StoreState) => ({
  selectDealerCallback: state.dsw.settings.selectDealerCallback,
  pageSize: Number(getConfigurationMarketProperty(
    state.dsw.configuration || {},
    state.dsw.settings.market,
    TemplateMarketPropertyKeys.DSW_SEARCH_RESULTS_PAGINATION_PAGE_SIZE
  ) || Globals.DEFAULT_DEALERS_PAGINATION_PAGE_SIZE),
  totalResults: state.dsw.search.totalResults
});

const mapDispatchToProps: Object = {
  findDealersListPage,
  setDealersListPage
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchResultsList);
